import * as React from 'react';
import PaymentMethodForm from "../../components/PaymentMethods/PaymentMethodForm/PaymentMethodForm";
var PaymentMethod = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432 \u043C\u0435\u0442\u043E\u0434 \u043D\u0430 \u043F\u043B\u0430\u0449\u0430\u043D\u0435"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: " offset-md-4 col-md-5" },
                    React.createElement(PaymentMethodForm, null))))));
};
export default PaymentMethod;



//////////////////
// WEBPACK FOOTER
// ./src/views/PaymentMethods/PaymentMethod.tsx
// module id = 396
// module chunks = 0